class AdpFileUploadController {
  constructor() {
    this.name = 'adpFileUpload';
    this.isAdded = false;
  }
  uploadFile() {
    this.isFileUploaded = true;
  }
  closeUpload() {
    this.isFileUploaded = false;
  }
  addFiles() {
    this.isAdded = true;
  }
}

export default AdpFileUploadController;



// WEBPACK FOOTER //
// ./src/app/components/adpFileUpload/adpFileUpload.controller.js